import { createTheme } from '@mui/material/styles';

const fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#818CF8',
      dark: '#6366F1',
      light: '#A5B4FC',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#94A3B8',
    },
    background: {
      default: '#161d2b',
      paper: '#1a2332',
    },
    text: {
      primary: '#F1F5F9',
      secondary: '#94A3B8',
    },
    divider: '#1e293b',
  },
  typography: {
    fontFamily,
    h2: {
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h6: {
      fontWeight: 600,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
    body2: {
      fontWeight: 400,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        contained: {
          padding: '10px 20px',
        },
        outlined: {
          borderColor: '#334155',
          color: '#CBD5E1',
          '&:hover': {
            borderColor: '#475569',
            backgroundColor: 'rgba(30, 41, 59, 0.5)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: '1px solid #243044',
          boxShadow: 'none',
          backgroundImage: 'none',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
        },
      },
    },
  },
});

export default theme;
